<template>
  <div class="scroll-container">
    <v-list-item class="no-scroll">
      <v-list-item-title class="text-h6">{{ $t("PropertiesTitle") }}</v-list-item-title>
      <v-list-item-action @click="setSideDrawer(null)" style="cursor: pointer">
        <img class="vis-icon" src="/img/toolbar/Close.svg" />
      </v-list-item-action>
    </v-list-item>
    <v-divider></v-divider>
    <v-list class="pt-0 scroll">
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title v-text="modelName"></v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item v-for="(value, key) in items" :key="key">
        <v-list-item-content>
          <v-list-item-title v-text="key"></v-list-item-title>
        </v-list-item-content>
        <v-list-item-content>
          <v-list-item-title v-text="value"></v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";

export default {
  components: {},
  data: () => ({
    modelName: "",
    items: {},
    defaultModelName: "",
    defaultData: {}
  }),
  computed: {
    ...mapState(["selectedItem"]),
    ...mapGetters(["viewerManager", "propertiesManager"])
  },
  watch: {
    selectedItem: function(newSelectedItem) {
      if (newSelectedItem.psId) {
        var propData = this.propertiesManager.getProperties(newSelectedItem.psId);
        if (propData) {
          var publicPropData = {};
          for (var key in propData.properties) {
            if (key.endsWith("") && key !== "_symbol_UserData") {
              if (propData.properties[key]) {
                publicPropData[key] = propData.properties[key];
              } else {
                publicPropData[key] = "UNKNOWN";
              }
            }
          }
          this.modelName = propData.name;
          this.items = publicPropData;
        }
      } else {
        this.modelName = this.defaultModelName;
        this.items = this.defaultData;
      }
    }
  },
  mounted: function() {
    this.$root.$on("modelLoaded", this.newModelLoaded);
  },
  methods: {
    ...mapMutations(["setSideDrawer"]),
    newModelLoaded: function(psId) {
      this.modelName = "";
      this.items = {};
      this.defaultModelName = "";
      this.defaultData = {};
      this.propertiesManager.loadProperties(psId, success => {
        if (success) {
          this.setDefaultData(psId);
        }
      });
    },
    setDefaultData: function(psId) {
      var propData = this.propertiesManager.getProperties(psId);
      if (propData) {
        var publicPropData = {};
        for (var key in propData.properties) {
          if (key.endsWith("") && key !== "_symbol_UserData") {
            if (propData.properties[key]) {
              publicPropData[key] = propData.properties[key];
            } else {
              publicPropData[key] = "UNKNOWN";
            }
          }
        }
        this.defaultModelName = propData.name;
        this.defaultData = publicPropData;

        this.modelName = this.defaultModelName;
        this.items = this.defaultData;
      }
    }
  }
};
</script>

<style scoped></style>
